import { render } from "./PhotographySkeleton.vue?vue&type=template&id=59209e38&scoped=true"
const script = {}

import "./PhotographySkeleton.vue?vue&type=style&index=0&id=59209e38&lang=sass&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59209e38"]])

export default __exports__